import AiRobot from './src/main';

/* istanbul ignore next */
AiRobot.install = function(Vue) {
  Vue.component(AiRobot.name, AiRobot);
};

export default AiRobot;
